const brochure_sizes = [
  { value: "small", label: "8.5 x 14" },
  { value: "medium", label: "11 x 17" },
  { value: "large", label: "12 x 18" },
  { value: "single", label: "8.5 x 11" },
];
const brochure_weights = {
  small: [{ value: "standard", label: "Lightweight Matte" }],
  medium: [
    { value: "standard", label: "Lightweight Gloss" },
    { value: "card", label: "Card Stock Gloss" },
  ],
  large: [{ value: "card", label: "Card Stock Gloss" }],
  single: [
    { value: "standard", label: "Lightweight Gloss" },
    { value: "card", label: "Card Stock Gloss" },
  ],
};
const brochure_bleeds = {
  small: { standard: [{ value: "3201", label: "No Bleed" }] },
  medium: {
    standard: [
      { value: "3202", label: "No Bleed" },
      { value: "3206", label: "Full Bleed" },
    ],
    card: [
      { value: "3212", label: "No Bleed" },
      { value: "3207", label: "Full Bleed" },
    ],
  },
  large: { card: [{ value: "3203", label: "No Bleed" }] },
  single: {
    standard: [{ value: "3209", label: "N/A" }],
    card: [{ value: "3210", label: "N/A" }],
  },
};

const brochure = {
  sizes: brochure_sizes,
  weights: brochure_weights,
  bleeds: brochure_bleeds,
};

const rackcard_bleeds = {
  small: {
    card: [
      { value: "3103", label: "No Bleed" },
      { value: "3101", label: "Full Bleed" },
    ],
  },
  large: {
    card: [
      { value: "3104", label: "No Bleed" },
      { value: "3102", label: "Full Bleed" },
    ],
  },
};

const rackcard_weights = {
  small: [{ value: "card", label: "Card Stock Gloss" }],
  large: [{ value: "card", label: "Card Stock Gloss" }],
};

const rackcard_sizes = [
  { value: "small", label: "4 x 6" },
  { value: "large", label: "4 x 9" },
];

const rack_card = {
  sizes: rackcard_sizes,
  weights: rackcard_weights,
  bleeds: rackcard_bleeds,
};

export const PRINT_OPTIONS = {
  brochure,
  rack_card,
};

export const DIGITAL_BROCHURE_SIZE_SKU = "print.digital_brochure.size";
